var MessageReceiverControlRegistrationParamsSerialiser =
        require('services/control/message-receiver-control-registration-params-serialiser');
var ConversationIDSerialiser = require('conversation/conversation-id-serialiser');
var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
        var params = MessageReceiverControlRegistrationParamsSerialiser.read(input);
        var cid = ConversationIDSerialiser.read(input);

        return {
            params : params,
            cid : cid
        };
    },
    write : function(output, request) {
        MessageReceiverControlRegistrationParamsSerialiser.write(output, request.params);
        ConversationIDSerialiser.write(output, request.cid);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/message-receiver-control-registration-request-serialiser.js
// module id = 1063
// module chunks = 1